import Resource from './Resource';
import { formatDateTime } from '../utils/format';

export default class ServiceRequest extends Resource {
  get occurrenceDateTime() {
    return formatDateTime(this.properties.occurrenceDateTime);
  }

  get values() {
    const values = this.properties.values;
    values.occurrenceDateTime = this.occurrenceDateTime;
    delete values.authoredOn; // duplicate of recordedAt
    return values;
  }
}


// WEBPACK FOOTER //
// ./src/models/ServiceRequest.js